<mat-card fxLayoutGap="15px">
  <div fxLayout="column" fxFlex>
    <div fxLayout="row" fxLayoutGap="10px" style="padding-bottom: 15px; font-size: 20px;">
      <mat-icon mat-list-icon [class]="getClassColor(deposit?.state)">folder</mat-icon>
      <div mat-line>{{depositSvc.displayStateNames(deposit?.state)}}</div>
    </div>

    <mat-card-subtitle class="msg-versement-incomplet" *ngIf="isIncompleteState()">{{deposit?.motif}}</mat-card-subtitle>
    <mat-card-content>
      <mat-list role="list" fxLayout="row">
        <mat-list-item role="listitem" fxFlex="33">
          <div fxLayout="column">
            <span class="lbl">Versement pris en charge le</span>
            <span class="ctt">{{displayIncDate()}}</span>
          </div>
        </mat-list-item>
        <mat-list-item role="listitem" fxFlex="33">
          <div fxLayout="column">
            <span class="lbl">Numéro de versement</span>
            <span class="ctt">{{deposit?.deposit_identifier}}</span>
          </div>
        </mat-list-item>
        <mat-list-item role="listitem" fxFlex *ngIf="editMode">
          <div fxLayout="row">
            <div fxLayout="column">
              <span class="lbl">Localisation</span>
              <span class="ctt">{{ displayLocation() }}</span>
            </div>
            <div *ngIf="deposit.state === depositState.ARCHIVED" style="margin-left: 10px">
              <button mat-mini-fab color="primary"
                      (click)="saveDepositArchived()">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </div>
        </mat-list-item>
      </mat-list>
    </mat-card-content>
    <mat-card-actions *ngIf="editMode">
      <form [formGroup]="depositForm">
      <button mat-raised-button *ngIf="isWaitingState()"
              [class]="helperDeposit.getClassColorBtnChip(depositState.INCOMPLETE)"
              (click)="saveDepositIncomplete()" data-cy="btn-take-charge-deposit-incomplete">
        Versement incomplet
      </button>
      <button mat-raised-button *ngIf="isWaitingState()"
              [class]="helperDeposit.getClassColorBtnChip(depositState.DONE)"
              (click)="saveDepositDone()" data-cy="btn-take-charge-validate">
        Valider le versement
      </button>
      <button mat-raised-button *ngIf="isValidatedState()"
              [class]="helperDeposit.getClassColorBtnChip(depositState.ARCHIVED)"
              (click)="saveDepositArchived()" data-cy="btn-take-charge-archive">
        Archiver dans le magasin
      </button>

        <mat-form-field appearance="outline">
          <mat-label><b>Sort final</b></mat-label>
          <mat-select  formControlName="conservation" (selectionChange)="setConservation($event)" [disabled]="locked">
            <mat-option *ngFor="let conservation of conservations"
                        [value]="conservation.id" [attr.data-cy]="'option-take-charge-' + conservation.id">{{ conservation.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <button [class]="['lock']" mat-raised-button color="primary"
                (click)="setPadlock()" data-cy="btn-take-charge-lock">
          <mat-icon>{{locked?'lock':'lock_open'}}</mat-icon>
        </button>
      </form>
    </mat-card-actions>
  </div>
</mat-card>
